import React from 'react';
import {
    Row,
    Col,
    Typography,
    Skeleton,
    Result,
    Statistic,
    Descriptions,
    Button,
    Divider,
    message
} from 'antd';
import {
    FileTextOutlined,
    PlusOutlined
} from '@ant-design/icons';
import { useParams, useNavigate } from 'react-router-dom';
import { useQuery, useMutation } from '@tanstack/react-query';
import dayjs from 'dayjs';

import { convertPaymentType, formatPhone } from '../../utils/customFunctions';
import OrderItems from './components/OrderItems';
import AddCashDoc from './components/AddCashDoc';
import EditCashDoc from './components/EditCashDoc';
import axios from '../../config/axios';

function Detail() {

    const { id } = useParams();
    const [messageApi, contextHolder] = message.useMessage();

    const docQuery = useQuery({ queryKey: [`/api/transactionDoc/getOrderDocByOrderId/${id}`] });
    const invoiceQuery = useQuery({ queryKey: [`/api/transaction/${id}`] });
    const redirect = useNavigate();

    const { isLoading, mutate } = useMutation({
        mutationFn: data => {
            axios
                .post('/api/transactionDoc/createTransactionDoc', data)
                .then(res => redirect(`/admin/orders/document/${res.data._id}`))
                .catch(err => {
                    console.log(err)
                    messageApi.open({
                        type: 'error',
                        content: 'ไม่สามารถบันทึกข้อมูลได้ ข้อมูลไม่ถูกต้อง',
                    });
                })
        },
    });

    if (invoiceQuery.isLoading || docQuery.isLoading) {
        return <Skeleton active />
    }

    if (invoiceQuery.isError || docQuery.isError) {
        return <Result status="error" title={invoiceQuery.error.message || docQuery.error.message} />
    };




    const handleCreateDoc = (info) => mutate(info);

    // console.log(invoiceQuery.data);
    // console.log('docQuery.data :', docQuery.data);
    return (
        <div style={{
            background: '#fff',
        }}>
            {contextHolder}
            <Row justify="end" gutter={[8, 0]}>
                {!docQuery.data.find(f => f.doc_type === 'BILLINGSLIP') ?
                    <Col>
                        <Button
                            icon={<PlusOutlined />}
                            onClick={() => handleCreateDoc({ doc_prefix: "TCBS", doc_type: "BILLINGSLIP", transaction: id })}
                            disabled={isLoading}
                            style={{
                                color: '#815CC1',
                                borderColor: '#815CC1'
                            }}
                        >สร้างใบวางบิล</Button>
                    </Col>
                    :
                    <Col>
                        <Button
                            icon={<FileTextOutlined />}
                            href={`/admin/orders/document/${docQuery.data.find(f => f.doc_type === 'BILLINGSLIP')._id}`}
                            style={{
                                color: '#815CC1',
                                borderColor: '#815CC1'
                            }}
                        >ใบวางบิล</Button>
                    </Col>}
                {!docQuery.data.find(f => f.doc_type === 'SHIPPINGNOTE') ?
                    <Col>
                        <Button
                            icon={<PlusOutlined />}
                            onClick={() => handleCreateDoc({ doc_prefix: "TCSN", doc_type: "SHIPPINGNOTE", transaction: id })}
                            disabled={isLoading}
                            style={{
                                color: '#FAAE1C',
                                borderColor: '#FAAE1C'
                            }}
                        >สร้างใบส่งสินค้า</Button>
                    </Col>
                    :
                    <Col>
                        <Button
                            icon={<FileTextOutlined />}
                            href={`/admin/orders/document/${docQuery.data.find(f => f.doc_type === 'SHIPPINGNOTE')._id}`}
                            style={{
                                color: '#FAAE1C',
                                borderColor: '#FAAE1C'
                            }}
                        >ใบส่งสินค้า</Button>
                    </Col>}
                {!docQuery.data.find(f => f.doc_type === 'INVOICE') ?
                    <Col>
                        <Button
                            icon={<PlusOutlined />}
                            onClick={() => handleCreateDoc({ doc_prefix: "TCIN", doc_type: "INVOICE", transaction: id })}
                            disabled={isLoading}
                            style={{
                                color: '#1677FF',
                                borderColor: '#1677FF'
                            }}
                        >สร้างใบแจ้งหนี้</Button>
                    </Col>
                    :
                    <Col>
                        <Button
                            icon={<FileTextOutlined />}
                            href={`/admin/orders/document/${docQuery.data.find(f => f.doc_type === 'INVOICE')._id}`}
                            style={{
                                color: '#1677FF',
                                borderColor: '#1677FF'
                            }}
                        >ใบแจ้งหนี้</Button>
                    </Col>
                }
                {!docQuery.data.find(f => f.doc_type === 'TAXINVOICE') ?
                    <Col>
                        <Button
                            icon={<PlusOutlined />}
                            onClick={() => handleCreateDoc({ doc_prefix: "TCTI", doc_type: "TAXINVOICE", transaction: id })}
                            disabled={isLoading}
                            style={{
                                color: '#ff76db',
                                borderColor: '#ff76db'
                            }}
                        >สร้างใบกำกับภาษี</Button>
                    </Col>
                    :
                    <Col>
                        <Button
                            icon={<FileTextOutlined />}
                            href={`/admin/orders/document/${docQuery.data.find(f => f.doc_type === 'TAXINVOICE')._id}`}
                            style={{
                                color: '#ff76db',
                                borderColor: '#ff76db'
                            }}
                        >ใบกำกับภาษี</Button>
                    </Col>
                }
                {!docQuery.data.find(f => f.doc_type === 'RECEIPT') ?
                    <Col>
                        <Button
                            icon={<PlusOutlined />}
                            onClick={() => handleCreateDoc({ doc_prefix: "TCRE", doc_type: "RECEIPT", transaction: id })}
                            disabled={isLoading}
                            style={{
                                color: '#32b300',
                                borderColor: '#32b300'
                            }}
                        >สร้างใบเสร็จรับเงิน</Button>
                    </Col>
                    :
                    <Col>
                        <Button
                            icon={<FileTextOutlined />}
                            href={`/admin/orders/document/${docQuery.data.find(f => f.doc_type === 'RECEIPT')._id}`}
                            style={{
                                color: '#32b300',
                                borderColor: '#32b300'
                            }}
                        >ใบเสร็จรับเงิน</Button>
                    </Col>
                }
            </Row>
            <Row justify='space-between' >
                <Col xs={24} md={12} >
                    <Typography.Title level={3}>
                        {`คำสั่งซื้อเลขที่ ${invoiceQuery.data.doc_no}`}
                    </Typography.Title>
                    {/* <Typography.Title level={4}>
                        {`คำสั่งซื้อเลขที่ ${invoiceQuery.data.doc_no}`}
                    </Typography.Title> */}
                </Col>
                <Divider />
                <Col xs={24}>
                    <Row justify="space-between">
                        <Col xs={12}>
                            <Row>
                                <Col xs={6}>
                                    <Typography.Text strong>
                                        ชื่อลูกค้า
                                    </Typography.Text>
                                </Col>
                                <Col>
                                    <Typography.Text type="secondary">
                                        {`${invoiceQuery.data.customer.fname} ${invoiceQuery.data.customer.lname ?? ""}`}
                                    </Typography.Text>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={6}>
                                    <Typography.Text strong>
                                        สถานที่จัดส่ง
                                    </Typography.Text>
                                </Col>
                                {invoiceQuery.data.shipment && <Col>
                                    <Typography.Text type="secondary">
                                        {invoiceQuery.data.shipment.address}
                                    </Typography.Text>
                                    <br />
                                    <Typography.Text type="secondary">
                                        {`แขวง/ตำบล${invoiceQuery.data.shipment.sub_district} อำเภอ${invoiceQuery.data.shipment.district}`}
                                    </Typography.Text>
                                    <br />
                                    <Typography.Text type="secondary">
                                        {`จังหวัด${invoiceQuery.data.shipment.province} รหัสไปรษณีย์ ${invoiceQuery.data.shipment.postalcode}`}
                                    </Typography.Text>
                                </Col>}
                            </Row>
                            <Row>
                                <Col xs={6}>
                                    <Typography.Text strong>
                                        โทร.
                                    </Typography.Text>
                                </Col>
                                <Col>
                                    <Typography.Text type="secondary">
                                        {formatPhone(invoiceQuery.data.customer.phone)}{invoiceQuery.data.customer.phone_2 && ` ; ${formatPhone(invoiceQuery.data.customer.phone_2)}`}
                                    </Typography.Text>
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={12}>
                            <Row>
                                <Col xs={6}>
                                    <Typography.Text strong>
                                        วันที่สั่งซื้อ
                                    </Typography.Text>
                                </Col>
                                <Col>
                                    <Typography.Text type="secondary">
                                        {dayjs(invoiceQuery.data.order_date).format('DD-MM-YYYY')}
                                    </Typography.Text>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={6}>
                                    <Typography.Text strong>
                                        วันที่ส่งของ
                                    </Typography.Text>
                                </Col>
                                <Col>
                                    <Typography.Text type="secondary">
                                        {dayjs(invoiceQuery.data.shipment_date).format('DD-MM-YYYY')}
                                    </Typography.Text>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={6}>
                                    <Typography.Text strong>
                                        วันที่วางบิล
                                    </Typography.Text>
                                </Col>
                                <Col>
                                    <Typography.Text type="secondary">
                                        {dayjs(invoiceQuery.data.billing_date).format('DD-MM-YYYY')}
                                    </Typography.Text>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={6}>
                                    <Typography.Text strong>
                                        ผู้ขาย
                                    </Typography.Text>
                                </Col>
                                <Col>
                                    <Typography.Text type="secondary">
                                        {invoiceQuery.data.employee.fname}
                                    </Typography.Text>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Col>
                <Divider />
                <Col xs={24}>
                    <OrderItems items={invoiceQuery.data.transaction_items} />
                </Col>
                <Divider />
                <Col xs={24}>
                    <Descriptions
                        title="รายละเอียดการชำระเงิน"
                        items={[
                            {
                                key: '1',
                                label: 'ประเภทการชำระสินค้า',
                                children: convertPaymentType(invoiceQuery.data.payment_type),
                            },
                            {
                                key: '2',
                                label: 'ราคารวม',
                                children: <Statistic value={invoiceQuery.data.total.toFixed(2)} precision={2} valueStyle={{ fontSize: 14, textAlign: 'right' }} />,
                            },
                            {
                                key: '3',
                                label: 'ส่วนลด',
                                children: <Statistic value={invoiceQuery.data.discount} precision={2} valueStyle={{ fontSize: 14, textAlign: 'right' }} />,
                            },
                            {
                                key: '4',
                                label: 'ภาษีมูลค่าเพิ่ม',
                                children: <Statistic value={invoiceQuery.data.vat.toFixed(2)} precision={2} valueStyle={{ fontSize: 14, textAlign: 'right' }} />,
                            },
                            {
                                key: '5',
                                label: 'ราคาสุทธิ',
                                children: <Statistic value={invoiceQuery.data.grand_total.toFixed(2)} precision={2} valueStyle={{ fontSize: 14, textAlign: 'right' }} />,
                            },
                            {
                                key: '6',
                                label: 'เพิ่มเติม',
                                children: invoiceQuery.data.description,
                            },
                        ]} />
                </Col>
                <Divider />
                {
                    !invoiceQuery.data.cash_doc && (invoiceQuery.data.payment_type !== '0' || invoiceQuery.data.payment_type === 'NA') &&
                    <Col xs={24}>
                        < AddCashDoc orderData={invoiceQuery.data} />
                    </Col>
                }
                {
                    !!invoiceQuery.data.cash_doc && (invoiceQuery.data.payment_type !== '0' || invoiceQuery.data.payment_type === 'NA') &&
                    <Col xs={24}>
                        <Row justify="end">
                            <Col>
                                <EditCashDoc orderData={invoiceQuery.data} />
                            </Col>
                            {/* <Col>
                                <DeleteCashDoc cashDocData={invoiceQuery.data.cash_doc} />
                            </Col> */}
                        </Row>
                        <Descriptions
                            title="รายละเอียดเอกสารการเงิน"
                            items={[
                                {
                                    key: '1',
                                    label: 'จ่าย',
                                    children: invoiceQuery.data.cash_doc.pay,
                                },
                                {
                                    key: '2',
                                    label: 'วันที่',
                                    children: dayjs(invoiceQuery.data.cash_doc.doc_date).format('DD-MM-YYYY'),
                                },
                                {
                                    key: '3',
                                    label: 'จ่าย',
                                    children: invoiceQuery.data.cash_doc.pay,
                                },
                                {
                                    key: '4',
                                    label: 'จำนวนเงิน',
                                    children: <Statistic value={invoiceQuery.data.cash_doc.the_sum_of} precision={2} valueStyle={{ fontSize: 14, textAlign: 'right' }} />,
                                },
                                {
                                    key: '5',
                                    label: 'ธนาคาร',
                                    children: invoiceQuery.data.cash_doc.bank_name,
                                },
                                {
                                    key: '6',
                                    label: 'สาขา',
                                    children: invoiceQuery.data.cash_doc.bank_branch,
                                },
                            ]} />
                    </Col>
                }
            </Row>
        </div>
    )
}

export default Detail